import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mb-2" }
const _hoisted_2 = {
  key: 0,
  class: "p-3"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "whitespace-nowrap text-sm font-medium not-italic text-gray-800" }, [
  /*#__PURE__*/_createTextVNode("Type"),
  /*#__PURE__*/_createElementVNode("span", { class: "pl-0.5 text-orange-600" }, "*")
], -1)
const _hoisted_4 = { class: "flex items-center justify-center" }
const _hoisted_5 = {
  key: 0,
  class: "mt-2 text-sm text-error"
}
const _hoisted_6 = { class: "mt-2 flex items-center gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_input_field = _resolveComponent("input-field")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "mt-4 flex cursor-pointer items-center gap-2 whitespace-nowrap text-sm font-medium not-italic text-gray-800",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showDeviceParentForm && _ctx.showDeviceParentForm(...args)))
    }, [
      _createTextVNode(_toDisplayString(_ctx.$t("Devices.ParentDeviceId")) + " ", 1),
      _createElementVNode("i", {
        class: _normalizeClass({
          'fa fa-chevron-up': _ctx.showParentDeviceForm,
          'fa fa-chevron-down': !_ctx.showParentDeviceForm,
        }),
        style: {"color":"#929bad"}
      }, null, 2)
    ]),
    (_ctx.showParentDeviceForm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("form", null, [
            _createElementVNode("div", null, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_v_select, {
                  class: _normalizeClass(`mt-1 w-full ${_ctx.selectedType == null && 'error'}`),
                  modelValue: _ctx.selectedType,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedType) = $event)),
                  options: _ctx.identifiers
                }, null, 8, ["class", "modelValue", "options"])
              ]),
              (_ctx.selectedType == null)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Value is required "))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_input_field, {
              modelValue: _ctx.identifier,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.identifier) = $event)),
              label: "Identifier",
              errorMessage: 'Value is required',
              isError: _ctx.identifier == ''
            }, null, 8, ["modelValue", "isError"]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_the_button, {
                text: 'Get device',
                onClick: _ctx.getParentDeviceId,
                type: 'button'
              }, null, 8, ["onClick"]),
              _createVNode(_component_the_button, {
                text: 'Clear',
                onClick: _ctx.clearParentDeviceId,
                type: 'button',
                variant: "outline"
              }, null, 8, ["onClick"]),
              _createElementVNode("div", null, _toDisplayString(_ctx.parentDevice), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}